import { render, staticRenderFns } from "./NucafeOrderInputs.vue?vue&type=template&id=6f9dff26&"
import script from "./NucafeOrderInputs.vue?vue&type=script&lang=js&"
export * from "./NucafeOrderInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports